import React, { useEffect, useRef } from 'react';
import QuizAdminQuestion from './QuizAdminQuestion';

export default function QuizAdmin(props) {

  const { quizInfo, quizStyle, selectedQuestionId } = props;
  const scrollRef = useRef(null);

  useEffect(() => {

    if (scrollRef && scrollRef.current)
    {
      scrollRef.current.scrollIntoView({ behavior: 'smooth' });
    }

  }, [selectedQuestionId])

  return (
    <div id="quiz">
      <div id="quizContent">
        {(quizInfo.questionList || []).map((question, idx) => 
          <div className="mb-2" ref={selectedQuestionId === question.id ? scrollRef : null}>
            <QuizAdminQuestion
              key={question.id}
              question={question}
              questionNumber={idx + 1}
              quizInfo={quizInfo}
              color={quizStyle.colorList[idx % quizStyle.colorList.length]}
            />
          </div>
        )}
      </div>
    </div>
  );
}